import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class BaseInput extends Component {
  static propTypes = {
    formControlProps: PropTypes.object,
    type: PropTypes.string,
    maxLength: PropTypes.number,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
    placeholder: PropTypes.string,
  }
  static defaultProps = {
    type: 'text',
  }
  constructor(props) {
    super(props)
    this.state = {
      showPassword: false,
    }
  }
  render() {
    const {
      formControlProps,
      type = 'text',
      maxLength,
      onChange,
      onBlur,
      disabled,
      readOnly,
      placeholder,
      ...extra
    } = this.props
    const state = this.state
    const changeState = getDiff => this.setState(state => ({ ...state, ...getDiff(state) }))

    return (
      <div className='form-control' {...formControlProps}>
        <input
          {...extra}
          className='form-control-input'
          data-type={type}
          type={type === 'password' && state.showPassword ? 'text' : type}
          maxLength={maxLength}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          readOnly={readOnly}
          placeholder={placeholder}
        />
        {type === 'password' && (
          <div
            className='form-control-password-button'
            onPointerUp={() => {
              changeState(state => ({ showPassword: !state.showPassword }))
            }}
          >
            <img onPointerDown={event => event.preventDefault()} src={require(`assets/img/${state.showPassword ? 'eye-off' : 'eye'}.svg`).default} alt="Show password" />
          </div>
        )}
      </div>
    )
  }
}
